function combineSideEffects(sideEffects, key) {
  return args => {
    return sideEffects.reduce((acc, sideEffect) => {
      if (sideEffect) {
        const currentFunction = sideEffect[key];
        if (currentFunction) {
          return currentFunction(acc);
        }
      }
      return acc;
    }, args);
  };
}
function getDerivedAttributes({
  element,
  sideEffects
}) {
  if (!sideEffects || sideEffects.length === 0) {
    return {};
  }
  const getDerivedAttributesCombined = combineSideEffects(sideEffects, 'getDerivedAttributes');
  return getDerivedAttributesCombined({
    element,
    attributes: element
  }).attributes;
}
function getDerivedDataFromHTML({
  data,
  htmlElement,
  sideEffects
}) {
  if (!sideEffects) {
    return data;
  }
  const getDerivedDataFromHTMLCombined = combineSideEffects(sideEffects, 'getDerivedDataFromHTML');
  return getDerivedDataFromHTMLCombined({
    htmlElement,
    data
  }).data;
}

export { combineSideEffects, getDerivedAttributes, getDerivedDataFromHTML };
